import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CART_STORE_TYPE, SavedCartComponentStore } from 'cart-data';
import { ProductTypes } from 'products-data';
import { CartItemResultListComponent, provideCartItemResultComponent } from '../../cart-item';
import { SavedCartItemComponentProviderComponent } from '../saved-cart-item-component-provider/saved-cart-item-component-provider.component';
import { SectionComponent } from 'page-layouts-ui';

const components = ProductTypes.Codes.All.map((type) =>
  provideCartItemResultComponent({
    type: ProductTypes.fromCode(type),
    component: SavedCartItemComponentProviderComponent,
    merge: true,
  }),
).flat();

@Component({
  selector: 'ideal-saved-cart-item-results',
  imports: [CartItemResultListComponent, SectionComponent],
  templateUrl: './saved-cart-item-results.component.html',
  styleUrl: './saved-cart-item-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CART_STORE_TYPE,
      useValue: SavedCartComponentStore,
    },
    components,
    provideCartItemResultComponent({
      type: ProductTypes.Standard,
      component: SavedCartItemComponentProviderComponent,
      merge: true,
    }),
  ],
})
export class SavedCartItemResultsComponent {
  private readonly _store = inject(SavedCartComponentStore);
  private readonly _items = computed(() => this._store.cartItems());
  protected readonly ids = computed(() => this._items().map((item) => item.id));
  protected readonly cart = computed(() => this._store.cart());
  protected readonly cartName = computed(() => this.cart()?.name ?? '');
  protected readonly title = computed(() => `Items in ${this.cartName()}`);
}
